import { Injectable, computed, inject, signal } from '@angular/core';
import { WorkflowDraftConfirmationService } from '../workflow-registry-diagnostics/workflow-draft-confirmation.service';

/** Protects the reusable asset buffer and uncertain upload outcomes across navigation. */
@Injectable({ providedIn: 'root' })
export class DocumentAssetsStateService {
  private readonly confirmation = inject(WorkflowDraftConfirmationService);
  readonly dirty = signal(false);
  readonly busy = signal(false);
  readonly isNavigationBlocked = computed(() => this.dirty() || this.busy());
  readonly isOperationInProgress = this.busy;
  setDirty(value: boolean): void {
    this.dirty.set(value);
  }
  setBusy(value: boolean): void {
    this.busy.set(value);
  }
  clear(): void {
    this.dirty.set(false);
    this.busy.set(false);
  }
  confirmNavigation(): boolean | Promise<boolean> {
    if (this.busy()) return false;
    if (!this.dirty()) return true;
    return this.confirmation.confirm({
      heading: 'Leave document asset edits?',
      message: 'Unsaved asset and brand settings will be lost.',
      confirmText: 'Leave without saving',
      cancelText: 'Stay on page',
    });
  }
}
